import React from "react";
import {
  View,
  ImageBackground,
  Dimensions,
  StyleSheet,
  ImageSourcePropType,
} from "react-native";
import Ripple from "react-native-material-ripple";
import normalizeSource from "app/utils/normalizeSource";
import { MainText, MainTitle } from "app/components/common";
import { isWeb } from "@microdoing/shared/utils/deviceDetectors";

const { width } = Dimensions.get("window");

const styles = StyleSheet.create({
  rippleContainer: {
    height: "100%",
    width: "100%",
    zIndex: 1,
  },
  container: {
    overflow: "hidden",
    backgroundColor: "transparent",
    zIndex: 0,
    alignSelf: "center",
    marginTop: 10,
    marginBottom: 20,
    height: "100%",
    width: isWeb ? 460 : width * 0.85,
    borderRadius: 8,
    flexDirection: "column",
    flex: 1,
    cursor: "pointer",
  },
  topHeaderContainer: {
    padding: 30,
    backgroundColor: "rgba(0, 0, 0, 0.25)",
    height: "100%",
  },
});

interface Props {
  backgroundSource: ImageSourcePropType;
  largeTitle?: string;
  subtitle?: string;
  label?: string;
  onPress: () => any;
}

const TrackCard = ({
  backgroundSource = {},
  largeTitle = "",
  subtitle = "",
  label = "",
  onPress = () => null,
}: Props) => {
  return (
    <ImageBackground
      borderRadius={8}
      resizeMode="cover"
      style={styles.container}
      source={normalizeSource(backgroundSource)}
    >
      <Ripple
        rippleColor="white"
        rippleDuration={1100}
        rippleContainerBorderRadius={8}
        style={styles.rippleContainer}
        onPress={onPress}
      >
        <View style={styles.topHeaderContainer}>
          <MainTitle variant="l6-bold" color="neutral.white" marginBottom="xxs">
            {label}
          </MainTitle>
          <MainTitle variant="l9-bold" color="neutral.white" marginBottom="xm">
            {largeTitle}
          </MainTitle>
          <MainText variant="l5-bold" color="neutral.white">
            {subtitle}
          </MainText>
        </View>
      </Ripple>
    </ImageBackground>
  );
};

export default TrackCard;
